export function futureDate() {
  return new Date().setDate(new Date().getDate() + 7);
}
